import { render, staticRenderFns } from "./FilialDashboardVisitas.vue?vue&type=template&id=147c2952&scoped=true"
import script from "./FilialDashboardVisitas.vue?vue&type=script&lang=js"
export * from "./FilialDashboardVisitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c2952",
  null
  
)

export default component.exports